export const DEFAULTPATH = '/wellComp'
window.DEFAULTPATH = DEFAULTPATH
export function getDefaultData() {
  return ''
}
